<template>
  <div class="ui-block">
    <div class="about-group-header" @click="changeDisplay" v-if="checkWidth">
      <span>About group</span>
      <md-icon v-if="customClass === 'displayNone'">arrow_right </md-icon>      
      <md-icon v-else>arrow_drop_down</md-icon>
      <p v-show="customClass === 'displayNone'" v-if="checkWidth">{{ group.description }}</p>        
    </div>
    
    <div class="ui-block-content" :class="customClass">
      <ul class="widget w-personal-info item-block">
        <li>
          <span class="title">About</span>
          <span class="text">{{ group.description }}</span>
        </li>
        <li>
          <span class="title">Created</span>
          <span class="text">{{ group.createdAt | date }}</span>
        </li>
        <li>
          <span class="title">ZIP code</span>
          <span class="text">{{ groupZip }}</span>
        </li>
        <li>
          <span class="title">Location</span>
          <span class="text">{{ group.city }}</span>
        </li>
        <li
          data-toggle="tooltip"
          data-placement="bottom"
          :data-original-title="privacyTooltip"
          :data-html="true"
          class="privacy-tooltip"
        >
          <span class="title">Privacy</span>
          <a class="text">{{ privacyName }}</a>
        </li>

        <li>
          <router-link :to="{ name: 'GroupsMembership'}" class="title">Members</router-link>
          <MembersHolder />
        </li>

        <li>
          <span class="title">Items</span>
          <a class = "text">{{ getCurrentGroupItems.length}} items posted </a>
        </li>
      </ul>
      <div class="mt-4">
        <SButtonMaterial buttonType="button" color="transparent" textColor="danger" class="btn-size" iconColor="danger"
          materialClass="dense" text="LEAVE GROUP" data-cy="btnLeaveGroup_grouPage" iconLeftText="logout"
          v-if="!loggedUserIsModerator && isMember" @button="openModalLeaveGroup" />
        <SButtonMaterial buttonType="button" class="btn-size" color="secondary" textColor="white" iconColor="white" materialClass="dense"
          :text="joinBtnVisible === 'public_non_member' ? 'JOIN GROUP' : 'ASK TO JOIN'" data-cy="btnJoinGroup_grouPage" :data-cy-groupname="group.name" iconLeftText="add"
          v-if="!isMember && !joinBtnDisabled" @button="openModal" />
        <SButtonMaterial v-if="!isMember && joinBtnDisabled" buttonType="button" class="btn-size" color="darker-grey" textColor="white" iconColor="white" materialClass="dense"
          text="RESEND REQUEST" data-cy="btnJoinGroup_grouPage" :data-cy-groupname="group.name" iconLeftText="add"
          @button="openModal" />
      </div>
    </div>
    <ModalWelcomeGroup/>
  </div>
</template>

<script>
import { PUBLIC, PRIVATE, HIDDEN } from "@/enum/group-privacy";
import GroupHelper from '../../mixins/GroupHelper.vue';
import MembersHolder from './MembersHolder.vue';
import groupPrivacy from '../../enum/group-privacy';
import UserHelper from '../../mixins/UserHelper.vue';
import SButtonMaterial from '../../material-components/atoms/SButtonMaterial.vue';
import ModalWelcomeGroup from "@/components/molecules/ModalWelcomeGroup.vue";
import * as  axios from'axios';
export default {
  name: "GroupIntro",
  components: {
    SButtonMaterial,
    MembersHolder,
    ModalWelcomeGroup,    
  },
  props: ["group", "joinBtnVisible", "joinBtnDisabled"],
  mixins: [GroupHelper, UserHelper],
  data() {
    return {
      customClass: 'displayNone',
      screenSize: window.innerWidth,
      state: undefined,
      city: undefined,
      country: undefined
    }
  },
  methods: {
    changeDisplay() {
      this.customClass = this.customClass === 'displayNone' ? 'displayShow' : 'displayNone'
    },  
    sizeOfScreen(){
      this.screenSize = window.innerWidth;
    },  
    openModal() {
      if (this.group.privacy === groupPrivacy.PUBLIC) {
        this.joinGroup({ groupId: this.group.id, groupName: this.group.name });
        $("#welcome-modal").modal("show");
      } else {
        $("#join-request").modal("show");
      }
    },
    isModerator(member) {
      return member.id === this.moderator.id;
    },
    openModalLeaveGroup() {
      $("#leave-group").modal("show");
    },
  },
  computed: {
    checkWidth() {
      return this.screenSize <= 1023;
    },
    privacyTooltip() {
      switch (this.group.privacy) {
        case PUBLIC:
          return "<span class='privacy-tooltip'>Public groups are visible in search results, and membership is open to any Swampum user.  In addition, while any user may view the messages and items available in a public group, only members may participate in discussions and transactions.</span>";
        case PRIVATE:
          return "<span class='privacy-tooltip'>Private groups are visible in search results, but membership is controlled by the group’s moderator.  Members may invite other users to join the group (subject to criteria set by the moderator).  Only members may see and participate in a private group’s activity.</span>";
        case HIDDEN:
          return "<span class='privacy-tooltip'>Hidden groups are not visible in search results, and membership is controlled by the group’s moderator.  Members may invite other users to join the group (subject to criteria set by the moderator).  Only members may see and participate in a private group’s activity.</span>";
        default:
          return "";
      }
    },
    lessThan18() {
      if (this.getCurrentGroupMembers.length > 18) {
        return this.getCurrentGroupMembers.slice(0, 18);
      }
      return this.getCurrentGroupMembers;
    },
    moderator() {
      const moderator = this.getModerator || {};
      if (moderator) return moderator;
      return null;
    },
    isMember() {
      return this.myGroups.find((group) => {
        return group.groupId === this.group.id;
      })
        ? true
        : false;
    },
    loggedUserIsModerator() {
      return this.loggedUser.id === this.moderatorId ? true : false;
    },
    privacyName() {
      switch (this.group.privacy) {
        case PUBLIC:
          return "Public";
        case PRIVATE:
          return "Private";
        case HIDDEN:
          return "Hidden";
        default:
          return "";
      }
    },
    groupZip() {
      const groupZipCode = this.moderator.zip;
      return groupZipCode;
    },
  },
  mounted() {
    $(".privacy-tooltip").tooltip();

    window.addEventListener('resize', () => {
      this.sizeOfScreen();
    });  
  },
  async created() {
    const url = 'https://app.zipcodebase.com/api/v1/search';
    const parametros = {
      apikey: '11ae8520-0f06-11ee-b81e-9ba872d04347',
      codes: this.moderator.zip,
      country: 'us'
    };

    const resposta = await axios.get(url, { params: parametros });
    
    this.city = resposta.data.results[this.moderator.zip][0].city;
    this.state = resposta.data.results[this.moderator.zip][0].state;
    this.country = resposta.data.results[this.moderator.zip][0].country_code;
  },
};
</script>

<style lang="scss" scoped>
.about-group-header {
  font-size: 16px;
  display: block;
  justify-content: space-between;
  padding: 10px 23px 0px;
  font-weight: bold;
  color: #3d3d3d;
}

.about-group-header i {
  margin: unset;
  cursor: pointer;
}
.join-group-btn-container {
  display: flex;
  justify-content: center;
}

.privacy-tooltip {
  font-size: 12px;
  text-transform: initial;
}

.w-personal-info li .text {
  color: #888da8 !important;
  font-size: 13px;
}

.about-group-header p {
  margin-top: 0.5em;
  max-width: 65em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8em;
  font-weight: normal;
  color: #888da8;
  margin-bottom: 10px
}

.md-icon {
  float: right;
}


img {
  max-width: 34px;
  max-height: 34px;
}

.w-faved-page li {
  width: unset;
  height: unset;
}

.moderator-icon.md-icon {
  color: $primary;
  width: 16px;
  min-width: 16px;
  height: 16px;
  background-color: $white;
  position: absolute;
  transform: translatex(20px) translatey(20px);
}

.title {
  font-weight: 700 !important;
  font-size: 16px;
  display: flex;
  align-items: center;
  font-style: normal;
  line-height: 25px;
  letter-spacing: 1.25px;
  color: $black  !important;
  opacity: 0.7;
}

.leave-group-btn {
  color: $danger;
}
@media screen and (max-width: 1023px) {
  .displayNone {
      display: none;
    }
    .displayShow {
      padding-top: unset;
      display: block;
    }
}
@media screen and (min-width: 1024px) {
  .btn-size {
    width: 100%;
  }
}
</style>

<style>
.text {
  overflow-wrap: break-word;
}

.join-group-btn-container .join-group-btn .md-ripple {
  width: unset;
}
</style>
